module.exports = __webpack_public_path__ + "img/shili_dong (2).e5aa82ec.png";